// @flow
import * as React from 'react';

import { FormattedMessage, injectIntl } from 'react-intl';
import { InputContainer, InputField, InputValidation, LabelField } from './styles';

type stringOrIntlProp = string | { id: string, defaultMessage: string };

type Props = {
    error: stringOrIntlProp,
    id: string,
    intl: $npm$ReactIntl$IntlShape,
    label: stringOrIntlProp,
    placeholder: stringOrIntlProp,
    showLabel: boolean,
    serverError: boolean,
    inputRef: boolean,
    touched: boolean
};

export function Input({
    id,
    intl: { formatMessage },
    error,
    label,
    placeholder,
    showLabel,
    serverError,
    touched,
    inputRef,
    ...props
}: Props) {
    /* eslint-disable camelcase */
    return (
        <InputContainer>
            {label && (
                <LabelField htmlFor={id}>
                    {typeof label === 'object' ? <FormattedMessage {...label} /> : label}
                </LabelField>
            )}
            <InputField
                {...props}
                error={error}
                id={id}
                innerRef={inputRef}
                // $FlowFixMe
                placeholder={typeof placeholder === 'object' ? formatMessage(placeholder) : placeholder}
                serverError={serverError}
                touched={touched}
            />
            <InputValidation error={error} role="alert" serverError={serverError} touched={touched}>
                {error && touched && (typeof error === 'object' ? <FormattedMessage {...error} /> : error)}
                {serverError &&
                    !touched &&
                    (typeof serverError === 'object' ? <FormattedMessage {...serverError} /> : serverError)}
            </InputValidation>
        </InputContainer>
    );
}
/* eslint-enable camelcase */

export default injectIntl(Input);



// WEBPACK FOOTER //
// ./src/components/widgets/input/index.js